import React, { useState } from "react";
import { Upload, Button, Card } from "antd";
import { InboxOutlined, InfoCircleOutlined, MoreOutlined } from "@ant-design/icons";
import { Table } from "antd";
import { Checkbox } from "antd";
import { RecentAutoData } from "../../../data";
const { Dragger } = Upload;
const AuditExceptions = () => {
  const [checked, setChecked] = useState(false);
  const columns = [
    {
      title: "Contract ID",
      dataIndex: "id",
      key: "id",
      sorter: true,
      align:"left"
      //   filteredValue: [searchText],
      //   onFilter: (value, record) => {
      //     return (
      //       String(record.trans_id).toLowerCase().includes(value.toLowerCase()) ||
      //       String(record.account_name)
      //         .toLowerCase()
      //         .includes(value.toLowerCase()) ||
      //       String(record.ndc).toLowerCase().includes(value.toLowerCase()) || String(record?.account_number).toLowerCase().includes(value.toLowerCase())
      //     );
      //   },
    },
    {
      title: "Contract Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
      align:"left"

    },
    // {
    //   title: "Monder",
    //   dataIndex: "sender",
    //   key: "sender",
    //   sorter: true,
    // },
    {
      title: "Submitted",
      dataIndex: "time",
      key: "time",
      sorter: true,
      align:"left"

    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   sorter: true,
    // },
  ];

  return (
    <div>
       <Card
        title={
          <div className="flex justify-between items-center">
            <span className="font-semibold text-[16px] leading-[100%] tracking-[0%] text-justify text-[#000833]">Audit Exceptions</span>
            <div className="flex items-center gap-4">
              <div className="-mr-1">
                <InfoCircleOutlined className="mr-2" />
                <MoreOutlined />
              </div>
            </div>
          </div>
        }>
      <div className="flex justify-between items-center">
        <label className="flex items-center gap-2 text-[15px] text-[#000833]">
          <Checkbox checked={checked} onChange={() => setChecked(!checked)} />
          Reviewed
        </label>
        <div className="flex items-center border border-gray-300 rounded-md px-3 py-1 text-sm text-[#000833]">
          <div className="w-4 h-4 rounded-full border-2 border-gray-600 flex items-center justify-center mr-2">
            <div className="w-2 h-2 rounded-full bg-gray-600"></div>
          </div>
          Periacartix diasosurree
        </div>
      </div>

      <div className="mt-8">
        <span className="cardtitle ">File Exception Details</span>
        <Table
          columns={columns}
          dataSource={RecentAutoData}
          //   pagination={pagination}
          //   onChange={handleTableChange}
          //   loading={loading}
          scroll={{ x: "max-content" }}
          rowKey="id"
          size="middle"
          className="custom-table user-tbl"
        />
      </div>
      </Card>
    </div>
  );
};

export default AuditExceptions;
